module.exports = __webpack_public_path__ + "static/media/invert.518ddde1.svg";